import React from 'react';
import { CardBody as KendoCardBody } from '@progress/kendo-react-layout';

/**
  * CardBody component wrapping KendoReact CardBody with all supported props.
  *
  * @param {object} props
  * @param {React.ReactNode} [props.children] - CardBody children elements.
  * @param {string} [props.className] - Additional classes for the CardBody.
  * @param {React.CSSProperties} [props.style] - Additional CSS styles.
  * @returns {JSX.Element}
*/
export const CardBody = ({ 
    className = '', 
    style = {}, 
    children
}) => (
  <KendoCardBody 
    className={className} 
    style={style}
  >
    {children}
  </KendoCardBody>
);